<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <button
            uilabMatButton="outlined"
            [uilabMatBadge]="example.count"
            uilabMatBadgeDescription="Unread notifications"
        >
            Notifications
        </button>
    </avd-code-example>
}
